<div class="loginWrap">

    <div class="leftPanel">
        <h2>Welcome to<br/>rail e-learning</h2>
        <div class="loginNav">
            <a href="javascript:void(0);" [routerLink]="['/privacy']">Privacy Policy</a>
            <a href="javascript:void(0);" [routerLink]="['/terms']">Terms of Services</a>
            <a href="javascript:void(0);" [routerLink]="['/contact_us']">Contact Us</a>
        </div>
    </div>
    <div class="rightPanel">
        <div class="loginContent">
            <h1 [routerLink]="['/']"><img src="assets/images/logo.svg" /> </h1>
            <form [formGroup]="contactForm">
                <div class="form-group">
                    <input type="text" class="form-control" formControlName="name"   placeholder="Enter Name" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" autocomplete="true">
                    <div *ngIf="submitted && f.name.errors">
                        <span *ngIf="f.name.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    </div>
                </div><div class="form-group">
                    <input type="email" class="form-control" formControlName="email" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter Email ID" autocomplete="true" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" >
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">Please provide a valid email address</span>
                    </div>
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" formControlName="phone" maxlength = "10"  placeholder="Enter Phone" [ngClass]="{ 'is-invalid': submitted && f.phone.errors }" >
                    <div *ngIf="submitted && f.phone.errors">
                        <span *ngIf="f.phone.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.phone.errors.pattern" class="text-mute text-danger errorText">Only Number except </span>
                        <span *ngIf="f.phone.errors.minLength" class="text-mute text-danger errorText">Please enter mininmum 10 digit</span>
                    </div>
                </div>
                <div class="form-group">
                    <textarea class="form-control" maxlength="250" #comment placeholder="Message" formControlName="message"></textarea>
                    <mat-hint align="end">{{comment.value.length}} / 250 characters</mat-hint>
                    <div *ngIf="submitted && f.message.errors">
                        <span *ngIf="f.message.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    </div>
                  </div>
               
                  <button type="submit" class="btn btn-link second-link" [routerLink]="['/']" >Cancel</button>
                <button type="submit" class="btn btn-primary" (click)="contactUs(contactForm.value)" >Send</button>
                <!-- <div class="forgot">
                    <a href="javascript:void(0);" [routerLink]="['/forgot']">Forgot Password?</a>
                </div> -->
              </form>
        </div>
        <!-- <div class="beforeContact">
            Do not have login and wish to get one? <a href="javascript:void(0);"[routerLink]="['/contact_us']">Contact us</a> with your details
        </div> -->
    </div>
    <!-- <div class="loginNav mobileNave">
        <a href="javascript:void(0);">Privacy Policy</a>
        <a href="javascript:void(0);">Terms of Services</a>
        <a href="javascript:void(0);">Contact Us</a>
    </div> -->
</div>

